var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer min-w-1400 max-w-1400"},[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"footer-links"},[_c('span',[_c('a',{attrs:{"href":"https://bsawv.subkamolplus.com/help/privacy_policy"}},[_vm._v("Chính sách bảo mật thông tin")])]),_c('p',{staticClass:"secondLine"},[_vm._v("Copyright © NGERN SAEN SABAI COMPANY LIMITED")])])])])
}]

export { render, staticRenderFns }